import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Copy, Check, Link2, ChevronDown, ChevronRight } from "lucide-react";

interface ShareLinkProps {
  url: string;
  title?: string;
  description?: string;
  defaultCollapsed?: boolean;
}

export function ShareLink({ url, title = "Your Access Link", description, defaultCollapsed = false }: ShareLinkProps) {
  const [copied, setCopied] = useState(false);
  const [collapsed, setCollapsed] = useState(defaultCollapsed);

  const fullUrl = `${window.location.origin}${url}`;

  const handleCopy = async () => {
    await navigator.clipboard.writeText(fullUrl);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="border border-app-primary/30 bg-app-primary/5 rounded-lg">
      <button
        type="button"
        className="w-full flex items-center gap-2 px-3 py-2 text-left"
        onClick={() => setCollapsed((c) => !c)}
      >
        {collapsed ? (
          <ChevronRight className="w-3.5 h-3.5 text-app-primary shrink-0" />
        ) : (
          <ChevronDown className="w-3.5 h-3.5 text-app-primary shrink-0" />
        )}
        <Link2 className="w-3.5 h-3.5 text-app-primary shrink-0" />
        <span className="text-sm font-medium text-app-text">{title}</span>
        {description && (
          <span className="text-xs text-app-text-muted ml-auto hidden sm:inline">{description}</span>
        )}
      </button>
      {!collapsed && (
        <div className="px-3 pb-3 space-y-2">
          <div className="flex gap-2">
            <Input
              value={fullUrl}
              readOnly
              className="text-xs font-mono h-8"
            />
            <Button
              variant="outline"
              size="icon"
              className="h-8 w-8 shrink-0"
              onClick={handleCopy}
              title="Copy link"
            >
              {copied ? (
                <Check className="w-3.5 h-3.5 text-app-success" />
              ) : (
                <Copy className="w-3.5 h-3.5" />
              )}
            </Button>
          </div>
          <p className="text-xs text-app-text-muted">
            Send this to your client so they can claim their account. You can always resend it if they lose it.
          </p>
        </div>
      )}
    </div>
  );
}
